<div class="d-flex flex-direction-column bg-image pt-3">
  <div class="d-flex col-10 col-lg-11 col-md-10 col-sm-9 mx-auto central-main mt-2">
    <img class="header-logo cursor-pointer" routerLink="/home" src="assets/svg/logo.svg" alt="header logo">
  </div>
  <div class="d-flex flex-direction-column justify-content-center align-items-center min-vh-100">
    <div class="verification-form-container flex-direction-column">
      @if (isVerified) {
        <div
          class="min_media alert alert-success d-flex align-items-center alert-dismissible fade show mb-6 successMessage">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M12 22.0001C17.5234 22.0001 22 17.5236 22 12.0001C22 6.47668 17.5234 2.00012 12 2.00012C6.47656 2.00012 2 6.47668 2 12.0001C2 17.5236 6.47656 22.0001 12 22.0001ZM16.4141 10.1642L11.4141 15.1642C11.0469 15.5314 10.4531 15.5314 10.0898 15.1642L7.58984 12.6642C7.22266 12.297 7.22266 11.7032 7.58984 11.34C7.95703 10.9767 8.55078 10.9728 8.91406 11.34L10.75 13.1759L15.0859 8.83606C15.4531 8.46887 16.0469 8.46887 16.4102 8.83606C16.7734 9.20325 16.7773 9.797 16.4102 10.1603L16.4141 10.1642Z"
              fill="#1ED030"/>
          </svg>
          <div class="success-text">{{ message | translate }}</div>
        </div>
      }
      <div class="verification-form bg-white shadow justify-content-center">
        <div class="login-form">
          <div class="text">
            <div class="text-verify"
              [ngClass]="{'am-or-ru': lang == Language.HY || lang == Language.RU}"
            >{{'verification.verify-account' | translate}}</div>
            @if (userPhoneNumber) {
              <div class="text-description">
                {{'verification.send_digit_code_to_phone' | translate}}
              </div>
            } @else {
              <div class="text-description">
                {{'verification.send_digit_code_to_email' | translate}}
              </div>
            }
          </div>
          <div class="text-center mt-20px">
            <p class="timer-verify">{{ formattedTime }}</p>
          </div>
          <div class="container mt-30px">
            <form class="d-flex justify-content-center">
              <input type="text" maxlength="1" class="form-control text-center code-input"
                     #codeInput
                     *ngFor="let digit of digits; let i = index"
                     [(ngModel)]="code[i]"
                     name="code{{i}}"
                     [ngClass]="{'invalid': isVerificationFailed}"
                     (change)="onVerificationCodeChange()"
                     (input)="validateInput(i, codeInput)"
                     (keydown)="onKeyDown($event, i,codeInput)"
                     (keyup)="onKeyUp($event, i,codeInput)"
                     (paste)="handlePaste($event, i)">
            </form>
            @if (isVerificationFailed) {
              <div class="error-message">
                {{ message | translate }}
              </div>
            }
          </div>
          <button class="verify-button mt-20px"
                  [disabled]="isVerifyButtonDisabled"
                  (click)="onVerify()">
            {{'verification.verify' | translate}}
          </button>
          <p class="resend-text mt-10px">
            {{'verification.didnt_receive_the_code' | translate}}
            @if (formattedTime <= MIDNIGHT) {
              <a class="text-primary line" (click)="resendCode($event)">{{'verification.resend_code' | translate}}</a>
            } @else {
              {{'verification.resend_code' | translate}}
            }
          </p>
        </div>
      </div>
    </div>
  </div>
</div>
